<div class="container">
    <div class="info" *ngIf="from==='study'">
        <img alt="enclave-saved" src="/assets/images/study_created.svg" />
        <owc-typography  [variant]="'title5'">
            {{ i18n.STUDY_SAVED.CONFIGURED_SUCCESSFULLY}}
        </owc-typography>
        <owc-typography >
            {{ i18n.STUDY_SAVED.DISPLAY_TEXT }}
        </owc-typography>
        <owc-button data-testid="study-saved-confirm-btn" (click)="studySaved()">
            {{ i18n.STUDY_SAVED.BTN_TEXT }}
        </owc-button>
    </div>
    <div class="info" *ngIf="from==='sub-study'">
        <img alt="enclave-saved" src="/assets/images/study_created.svg" />
        <owc-typography  [variant]="'title5'">
            {{ i18n.SUB_STUDY_SAVED.CONFIGURED_SUCCESSFULLY}}
        </owc-typography>
        <owc-typography >
            {{ i18n.SUB_STUDY_SAVED.DISPLAY_TEXT }}
        </owc-typography>
        <owc-button data-testid="study-saved-confirm-btn-2" (click)="studySaved()">
            {{ i18n.SUB_STUDY_SAVED.BTN_TEXT }}
        </owc-button>
    </div>
</div>